export default import.meta.ROLLDOWN_FILE_URL_AsFALiR8IeZG9JJmQmaurw